module.exports = __webpack_public_path__ + "img/deal.993adab4.png";